import React from "react";
import { css } from "@emotion/react";
import { Icon, ToolTip, Font } from "@moneyforward/mfx_biz_react_components";
import { FormCheckBox } from "@/components/molecules/forms/FormCheckBox";
import { useIsSpMode } from "@/hooks";
import config from "@/libs/config";

type Props = {
  name: string;
};

const connectToBizsolFormCheckBox = (
  props: Props,
  ref: React.ForwardedRef<HTMLInputElement>
) => {
  const isSpMode = useIsSpMode();
  return (
    <div css={!isSpMode ? container : {}}>
      <div css={labelWrapper}>
        <Font variant="m" component="p" css={toolTip}>
          {config.BIZSOL_DISPLAY_NAME}連携
          <ToolTip
            variant="guide"
            text={`招待する方が${config.BIZSOL_DISPLAY_NAME}をご利用でない場合、チェックを外してください。`}
          >
            <Icon name="help" hasAction css={{ margin: "0 4px 0 4px" }} />
          </ToolTip>
        </Font>
      </div>
      <div css={inputWrapper}>
        <FormCheckBox name={props.name} ref={ref} css={{ margin: "4px" }} />
      </div>
    </div>
  );
};

export const ConnectToBizsolFormCheckBox = React.forwardRef(
  connectToBizsolFormCheckBox
);

const container = css({
  display: "flex",
  alignItems: "center",
});

const labelWrapper = css({
  width: "300px",
  marginTop: "8px",
  marginRight: "15px",
  paddingBottom: "4px",
});

const inputWrapper = css({
  width: "100%",
  marginTop: "3px",
});
const toolTip = css({
  display: "flex",
  alignItems: "center",
});
